import { ProfitAndLossMonthlyData } from "@/types/profit-and-loss-monthly-api";
import MonthlyTable from "./monthly/MonthlyTable";
import LoadingPage from "../LoadingPage";

type YM = { year: number; month: number };
type RangeFilter = { from: YM; to: YM };

interface ProfitAndLossMonthlyProps {
  data: ProfitAndLossMonthlyData;
  clientId: string;
  connectionId: string;
  range: RangeFilter;
}

const ProfitAndLossMonthly = ({
  data,
  clientId,
  connectionId,
  range,
}: ProfitAndLossMonthlyProps) => {
  if (!data) return <LoadingPage />;
  return (
    <div className="bg-white rounded-2xl w-full p-8 shadow-sm">
      <MonthlyTable
        monthlyData={data}
        clientId={clientId}
        connectionId={connectionId}
        dateRange={range}
      />
    </div>
  );
};

export default ProfitAndLossMonthly;
